<template lang="html">
  <v-container
    grid-list-lg
    pt-0
    mb-4
    fluid
  >
    <v-layout
      wrap
      justify-center
    >
      <v-flex v-bind="_pageLayout">
        <v-flex
          mt-4
          mb-6
          xs12
        >
          <span class="headline font-weight-light">Checkout</span>
        </v-flex>
        <v-flex
          v-if="!complete && !checkoutUsed"
          xs12
        >
          <SiCheckout
            ref="checkout"
            :skus="skus"
            :client-details="client"
            :register-paths="registerPaths"
            :register-paths-db="registerPathsDb"
            :charge-description="chargeDescription"
            :transaction-id="transactionId"
            :checkout-id="checkoutId"
            default-button-text="Checkout"
            phone
            allow-invoicing
            hide-client-type
            @finalised="checkoutComplete"
          />
        </v-flex>
        <v-flex v-else-if="!checkoutUsed">
          <v-alert 
            type="success" 
            color="teal"
            icon="check_circle"
            prominent
          >
            {{ successText }}
              
            <v-layout
              mt-4
              justify-end
            >
              <v-flex shrink>
                <v-btn
                  outlined
                  white
                  href="/"
                >
                  Take me home
                </v-btn>
              </v-flex>
            </v-layout>
          </v-alert>
        </v-flex>
        <v-flex
          v-if="checkoutUsed"
          xs12
        >
          <v-alert
            type="warning"
            icon="info"
            outlined
          >
            <div v-if="checkoutUsedSource === 'invoice'">
              An invoice was generated on {{ _formatDateTime(checkoutUsed) }}. Please contact us if you did not receive your invoice.
            </div>
            <div v-else>
              Payment has already been received on {{ _formatDateTime(checkoutUsed) }}. You do not need to complete the checkout again.
            </div>
            <v-layout
              mt-4
              justify-end
            >
              <v-flex shrink>
                <v-btn
                  outlined
                  color="warning"
                  href="/"
                >
                  Take me home
                </v-btn>
              </v-flex>
            </v-layout>
          </v-alert>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-overlay
      v-if="loading"
      color="white"
    >
      <v-progress-circular
        indeterminate
        color="teal"
      />
    </v-overlay>
  </v-container>
</template>

<script>
import axios from "axios";
import uniqid from "uniqid";
import { mapGetters } from "vuex";
import helpers from '@/mixins/helpers'


export default {
  mixins: [ helpers ],
  data() {
    return {
      checkoutId: '', 
      skus: [],
      client: {},
      chargeDescription: "",
      registerPaths: [],
      registerPathsDb: [],
      successText:
        "Thank you for your purchase. You should receieve your receipt shortly.",
      loading: true,
      complete: false,
      checkoutUsed: false,
      transactionId: uniqid(),
    };
  },
  computed: {
    ...mapGetters(["_pageLayout"]),
  },
  async beforeMount() {
    const { token, raiseInvoice } = this.$route.query;
    const { data } = await axios.get(
      `${process.env.VUE_APP_API_URL}/checkout?token=${token}`
      )
      
    const {
        id,
        skus,
        client,
        chargeDescription,
        transactionId,
        successText,
        successTextInvoice,
        registerPaths = [],
        registerPathsDb = [],
        complete,
        source,
    } = data;

    if (complete) {
      this.checkoutUsed = complete
      this.checkoutUsedSource = source
      this.loading = false
    } else {
      this.checkoutId = id
      this.client = client;
      this.skus = skus;
      this.chargeDescription = chargeDescription;
      this.registerPaths = registerPaths;
      this.registerPathsDb = registerPathsDb;
      this.successText = successText || this.successText;
      this.transactionId = transactionId
      if (raiseInvoice && this.$refs.checkout) {
        this.successText = successTextInvoice || this.successText
        this.$nextTick(() => {
          this.$refs.checkout.raiseInvoice()
          this.loading = false;
        })
      } else {
        this.loading = false;
      }
    }
  },
  methods: {
    checkoutComplete() {
      this.complete = true;
    },
  },
};
</script>

<style lang="css" scoped>
</style>
